import { TDeviceType } from '@cian/ui-kit';

export enum EPageType {
  Career = 'career',
  CareerVacancies = 'careerVacancies',
  CareerVacancy = 'careerVacancy',
  CareerTeamMarketing = 'careerTeamMarketing',
  CareerTeamAnalytics = 'careerTeamAnalytics',
  CareerTeamTechnologies = 'careerTeamTechnologies',
  CareerTeamProduct = 'careerTeamProduct',
  CareerTeamBackoffice = 'careerTeamBackoffice',
  Listing = 'listing',
  Card = 'card',
}

export interface IPageState {
  type: EPageType;
  deviceType: TDeviceType;
}
